import React, { useEffect, useState } from "react";
import { ClockIcon, FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 200;
function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownUrgency() {
  const [secondsLeft, setSecondsLeft] = useState(3 * 3600 + 42 * 60 + 15);
  // Spots remaining (urgency): start below total
  const spotsLeft = 37;
  useEffect(() => {
    const t = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(t);
  }, []);
  const h = Math.floor(secondsLeft / 3600);
  const m = Math.floor(secondsLeft % 3600 / 60);
  const s = secondsLeft % 60;
  const pct = Math.round(spotsLeft / TOTAL_SPOTS * 100);
  return <div className="rounded-2xl border border-red-500/30 bg-red-500/10 p-4" data-id="element-116" data-mp="1w58l6pqhz6pb">
      <div className="flex items-center justify-center gap-2 text-red-400" data-id="element-117" data-mp="6o7nc1cxww9h">
        <FlameIcon className="h-4 w-4" data-id="element-118" data-mp="1q63he7owswy" />
        <span className="text-[13px] font-bold uppercase tracking-wide" data-id="element-119" data-mp="1r7nw9alirrc">
          La oferta termina en
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-120" data-mp="2jp6z7opxv057">
        {[{
        v: h,
        l: "hrs"
      }, {
        v: m,
        l: "min"
      }, {
        v: s,
        l: "seg"
      }].map((unit, i) => <React.Fragment key={i} data-id="element-121" data-mp="2sq51o2kqazlo" data-mpi={i}>
            <div className="flex min-w-[56px] flex-col items-center rounded-xl bg-black px-2 py-2" data-id="element-122" data-mp="2xj7v8apia91v">
              <span className="font-display text-2xl leading-none text-white" data-id="element-123" data-mp="32ikk10zxtq73">
                {pad(unit.v)}
              </span>
              <span className="mt-1 text-[10px] uppercase text-white/50" data-id="element-124" data-mp="37fayjjw3gdqe">
                {unit.l}
              </span>
            </div>
            {i < 2 && <span className="font-display text-xl text-red-400" data-id="element-125" data-mp="3ghkbegeu4j6y">:</span>}
          </React.Fragment>)}
      </div>

      <div className="mt-4" data-id="element-126" data-mp="1i2pmowma87bc">
        <div className="mb-1.5 flex items-center justify-between text-[12px]" data-id="element-127" data-mp="1i3ikh839jmhc">
          <span className="flex items-center gap-1 text-white/70" data-id="element-128" data-mp="1m4kn7ywe2go2">
            <ClockIcon className="h-3.5 w-3.5" data-id="element-129" data-mp="2pe6v3zco5ct8" /> Cupos restantes
          </span>
          <span className="font-bold text-red-400" data-id="element-130" data-mp="2pg9uh9zpoiam">
            {spotsLeft} / {TOTAL_SPOTS}
          </span>
        </div>
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-131" data-mp="2yevdf693hzbx">
          <div className="h-full rounded-full bg-gradient-to-r from-red-500 to-red-400" style={{
          width: `${pct}%`
        }} data-id="element-132" data-mp="2ycse1vm1ytuj" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-white/50" data-id="element-133" data-mp="38bq8tga2njlz">
          Se están agotando rápido — no te quedes sin tu copia.
        </p>
      </div>
    </div>;
}